(function () {

  window.addEventListener('touchstart', function (event) {
    if (document.activeElement.tagName.toLowerCase() == 'abbr') {
      document.activeElement.blur();
    }
  });
  function keydown(event) {
    if (event.key === "Escape") {
      document.activeElement.blur();
    }
  }
  let abbrs = document.querySelectorAll("abbr");
  for (let i = 0; i < abbrs.length; i++) {
    let abbr = abbrs[i];
    abbr.dataset.title = abbr.title;
    abbr.removeAttribute('title');
    abbr.setAttribute('tabindex', '0');
    abbr.addEventListener('touchstart', function () { this.focus(); });
    abbr.addEventListener('keydown', keydown);
  }

})();
